import { Component, HostBinding, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia, MediaChange } from '@angular/flex-layout';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';

import { NotificationItem, NotificationTermInfo } from '../../notification/notification.service';
import { FormStatusPipe } from '../../../pipes/formstatus.pipe';

@Component({
    selector: 'dialog-classicnotification-component',
    styleUrls: ['classicnotification.dialogcomponent.css'],
    templateUrl: 'classicnotification.dialogcomponent.html',
})
export class ClassicNotificationDialogComponent implements OnInit, OnDestroy {
    @HostBinding('class.smalldisplay') SmallDisplay: boolean;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sorter: MatSort;

    private _subrelease: Subject<void> = new Subject<void>();

    TitleText: string;
    LastSizeCode: string;
    MessageText: string;
    Details: NotificationTermInfo[];
    DetailsData: DataTableSource<NotificationTermInfo>;
    IsAdvisor: boolean = false;
    VisibleHeaders: string[];
    VisibleColumns: string[];

    constructor(
        public dialogRef: MatDialogRef<ClassicNotificationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: BaseClassicNotificationDialogOptions,
        private mediaChange: ObservableMedia,
        private formStatusPipe: FormStatusPipe,
        private router: Router
    ) {
        this.TitleText = data.TitleText || 'Notification Details...';
        this.MessageText = data.MessageText || '';
        this.Details = data.Details || [];
        this.IsAdvisor = data.IsAdvisor || false;
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
            ? 'sm'
            : self.mediaChange.isActive('md')
            ? 'md'
            : self.mediaChange.isActive('lg')
            ? 'lg'
            : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.VisibleHeaders = self.SmallDisplay
            ? ['SmallDisplay']
            : this.IsAdvisor
                ? ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'SchoolName', 'FormStatus', 'DateUpdated', 'Actions']
                : ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'DateUpdated', 'Actions']
            ;
        self.VisibleColumns = self.VisibleHeaders.slice();

        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(media => {
                self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
                self.LastSizeCode = media.mqAlias;
                self.VisibleHeaders = self.SmallDisplay
                    ? ['SmallDisplay']
                    : this.IsAdvisor
                        ? ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'SchoolName', 'FormStatus', 'DateUpdated', 'Actions']
                        : ['StudentName', 'StudentID', 'College', 'CollegeTerm', 'DateUpdated', 'Actions']
                ;
                self.VisibleColumns = self.VisibleHeaders.slice();
            });

        this.DetailsData = new DataTableSource<NotificationTermInfo>(this.Details, self.paginator, self.sorter, self.SortNotifications.bind(this));
    }

    // #region Go To Route Method

    // GoToRoute(detail: NotificationEntry) {
    //     //if (!detail || !detail.NavigationRoute || !detail.NavigationRoute.length) return;

    //     // Close the dialog
    //     this.dialogRef.close();

    //     // Route to the provided route
    //     //this.router.navigate(detail.NavigationRoute);
    // }

    // #endregion

    // #region OK Handler

    OKHandler() {
        this.dialogRef.close(<NotificationTermInfo>null);
    }

    // #endregion

    // #region Sort Notifications Method

    SortNotifications(First: NotificationTermInfo, Second: NotificationTermInfo) {
        const self = this;

        let PropA: string | number | Date;
        let PropB: string | number | Date;

        switch (self.sorter.active) {
            case 'StudentName':
                [PropA, PropB] = [First.StudentName, Second.StudentName];
                break;
            case 'StudentID':
                [PropA, PropB] = [First.StudentID, Second.StudentID];
                break;
            case 'SchoolName':
                [PropA, PropB] = [First.SchoolName || "", Second.SchoolName || ""];
                break;
            case 'FormStatus':
                [PropA, PropB] = [First.FormStatus, Second.FormStatus];
                break;
            // case 'FormStatus':
            //     [PropA, PropB] = [
            //         self.formStatusPipe.transform(First.FormStatus, false),
            //         self.formStatusPipe.transform(Second.FormStatus, false),
            //     ];
            //     break;
        }

        const ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
        const ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;

        return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
    }

    // #endregion

    // #region View College Method

    ViewCollege(college: NotificationTermInfo) {
        const result = <NotificationTermInfo>{
            DualEnrollStudentID: college.DualEnrollStudentID,
            StudentName: college.StudentName,
            StudentID: college.StudentID,
            CollegeID: college.CollegeID,
            Term: college.Term,
        };

        this.dialogRef.close(result);
    }

    // #endregion
}

// #region Custom Classes

// #region Classic Notification Dialog Options Class

export class BaseClassicNotificationDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Details?: NotificationTermInfo[];
    IsAdvisor?: boolean;
}

// #endregion

// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/classicnotification/classicnotification.dialogcomponent.ts